import {selector} from './selector';
import * as events from "./events";

const PageCustomerProfilePrepaidRefundRequest = (function ($) {

    function initEvents() {
        $(document).on('change', selector.ddlBank, events.getBank);
        $(document).ready(function() {
            $('#tagSerialNumber').select2({
                language: {
                    noResults: function() {
                        return "";
                    }
                }
            });
        });
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerProfilePrepaidRefundRequest};
